/**
 * Read more: toggle dots/more met display. Labels komen uit WPML (data-attributen).
 */
import $ from "jquery";

$(document).ready(function () {
	$(document).on("click", ".text-read-more__btn", function (e) {
		e.preventDefault();
		const $btn = $(this);
		const $container = $btn.closest(".text-read-more");
		const expanded = $container.hasClass("is-expanded");

		// Haal labels uit data-attributen (WPML)
		const labelMore = $btn.data("label-more") || "Lees meer";
		const labelLess = $btn.data("label-less") || "Lees minder";

		$container.toggleClass("is-expanded", !expanded);
		$btn
			.attr("aria-expanded", !expanded)
			.text(expanded ? labelMore : labelLess);
	});
});
